class MuxSource {
    constructor() {
        this._source = undefined;
        this._events = undefined;

        this._trackers = new Set();
    }

    setSource(source, events) {
        this._source = source;
        this._events = events;

        for (const mux of this._trackers) {
            mux.setSource(source, events);
        }
    }

    addTracker(muxTracker) {
        if (this._trackers.has(muxTracker)) {
            return;
        }

        this._trackers.add(muxTracker);
        muxTracker.setSource(this._source, this._events);
    }

    removeTracker(muxTracker) {
        if (!this._trackers.has(muxTracker)) {
            return;
        }

        muxTracker.setSource();
        this._trackers.delete(muxTracker);
    }
}

export default MuxSource;
